// extracted by mini-css-extract-plugin
export var copyableField = "_s3-4";
export var customerBadge = "_s3-0";
export var customerInfoTitle = "_s3-2";
export var details = "_s3-1";
export var dropdownContainer = "_s3-5";
export var dropdownImage = "_s3-6";
export var editAssigneeForm = "_s3-a";
export var editButton = "_s3-3";
export var email = "_s3-7";
export var hidden = "_s3-d";
export var input = "_s3-8";
export var saveButton = "_s3-b";
export var shopifyIcon = "_s3-c";
export var suggestionBadge = "_s3-e";
export var suggestionText = "_s3-f";
export var username = "_s3-9";